export default "__VITE_ASSET__D_XzchBc__"